import { IssueContentRestrictions } from '@pressreader/content-types';
import { httpGet } from '@pressreader/services';

import { IGlobalContentRestrictionsItemDto, IIssueContentRestrictionsItemDto } from '../types/restrictions';

function getContentRestrictions() {
    return httpGet<IGlobalContentRestrictionsItemDto[]>('contentRestrictions');
}

function getIssueContentRestrictions(issue: string) {
    return httpGet<IssueContentRestrictions | IIssueContentRestrictionsItemDto[]>('contentRestrictions', 'issues', { issues: issue });
}

export { getIssueContentRestrictions, getContentRestrictions };
